import React from 'react';
import { getImg } from '@/pages/home/_config/getImgs';
import { useIntl } from 'umi';
import '@/pages/intelligence/assets/scss/Base/nodata.scss';

export default function NoData() {
  const { formatMessage } = useIntl();

  return (
    <div className="dbi-search-nodata">
      <img src={getImg('no-data')} className="dbi-search-nodata-img" />
      <div className="dbi-search-nodata-title">
        {formatMessage({ id: `dbi_no_results_found` })}
      </div>
      <div className="dbi-search-nodata-text">
        {formatMessage({ id: 'dbi_report_search_no_data_desc_line1' })}
        <br />
        {formatMessage({ id: 'dbi_report_search_no_data_desc_line2' })}
      </div>
    </div>
  );
}
